import {Button, ButtonGroup, useFormContext} from 'platform/components';

import i18n from '@dms/i18n';

import {VehicleSeriesDefinitionFormType} from '../types';

type VehicleSeriesDefinitionFormButtonsProps = {
  onCancel?: () => void;
  submitLabel: string;
  cancelTestId: string;
  submitTestId: string;
};

export const VehicleSeriesDefinitionFormButtons = (
  props: VehicleSeriesDefinitionFormButtonsProps
) => {
  const {formState} = useFormContext<VehicleSeriesDefinitionFormType>();

  return (
    <ButtonGroup align="right">
      <Button
        onClick={props.onCancel}
        data-testid={props.cancelTestId}
        variant="secondary"
        title={i18n.t('general.actions.cancel')}
      />
      <Button
        type="submit"
        isLoading={formState.isSubmitting}
        data-testid={props.submitTestId}
        title={props.submitLabel}
      />
    </ButtonGroup>
  );
};
